<template>
  <div>
    <van-nav-bar
      title="数据列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div>
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="10"
      >

        <div class="detalis-page">
          <ul>
            <li><span>水位(m)</span><span>流量(m³/s)</span><span>电压(v)</span><span>时间</span></li>
            <li v-for="item in list">
              <span>{{ item.water_level }}</span>
              <span>{{ item.water_volume }}</span>
              <span>{{ item.voltage }}</span>
              <span class="datalis-sp">{{ item.see_times }}</span>
            </li>
          </ul>
        </div>
      </van-list>
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DeviceDetailsPage",
  created() {
    //创建组件时，加载第1页数据
    this.getInstrumentList();
  },
  data() {
    return {
      title: null,
      list: [],
      loading: false,
      finished: false,
      station_address_id: null,
      page: 1,//请求第几页
      page_size: 20,//每页请求的数量
    };
  },
  methods: {
    getInstrumentList() {
      var that = this
      let dataInfo = {
        pagesize: that.page_size,
        page: that.page,
        station_address: that.$Request.station_address
      };
      axios({
        method: 'post',
        url: 'monitor/report_data_list',
        data: dataInfo
      }).then(function (response) {
        if (response.data.code == 1) {
          that.loading = false;
          let rows = response.data.data.list; //请求返回当页的列表
          let total = response.data.data.count;
          if (rows == null || rows.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          that.list = that.list.concat(rows);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.list.length >= total) {
            that.finished = true;
          }
        } else {
          that.list = null
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    onClickLeft() {
      let station_address = this.$Request.station_address;
      this.$router.push('/Index?station_address=' + station_address);
    },
    onLoad() {
      this.page++;
      this.getInstrumentList()
    },
  },
  beforeMount() {
    this.station_address_id = this.$Request.station_address
  }
}
</script>

<style scoped lang="scss">
.detalis-page {
  padding: 0 15px;
  background: #f7f7f7;

  ul {

    li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #cccccc;
      font-size: 12px;

      span {
        height: 40px;
        line-height: 40px;
        display: inline-block;

      }

      span:nth-child(1) {
        width: 21%;
      }

      span:nth-child(2) {
        width: 26%;
      }

      span:nth-child(3) {
        width: 17%;
      }

    }

    li:first-child {
      span:nth-child(2) {
        padding-left: 10px;
      }

      span:nth-child(5) {
        padding-left: 30px;
      }
    }
  }

}

.detalis-page-pressure {
  padding: 0 15px;
  background: #f7f7f7;

  ul {

    li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #cccccc;
      font-size: 12px;

      span {
        height: 40px;
        line-height: 40px;
        display: inline-block;
        width: 30%;
      }


    }


  }

}

</style>



// WEBPACK FOOTER //
// src/components/DeviceDetailsPage.vue